function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_3412",
  "data-name": "Grupo 3412"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_215",
  "data-name": "Ret\\xE2ngulo 215",
  width: 30,
  height: 30,
  fill: "none"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_3413",
  "data-name": "Grupo 3413",
  transform: "translate(3.333 3.333)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_116",
  "data-name": "Caminho 116",
  d: "M18.667,2A16.667,16.667,0,1,0,35.333,18.667,16.673,16.673,0,0,0,18.667,2Zm0,30A13.333,13.333,0,1,1,32,18.667,13.351,13.351,0,0,1,18.667,32ZM20.15,17.167c-2.967-.983-4.4-1.6-4.4-3.167,0-1.7,1.85-2.317,3.017-2.317a3.22,3.22,0,0,1,3.167,2.233L24.567,12.8a5.709,5.709,0,0,0-4.433-3.717V7H17.217V9.1a5.14,5.14,0,0,0-4.367,4.933c0,3.783,3.75,4.85,5.583,5.517,2.633.933,3.8,1.783,3.8,3.383,0,1.883-1.75,2.683-3.3,2.683-3.033,0-3.9-3.117-4-3.483L12.167,23.25A6.728,6.728,0,0,0,17.2,28.183v2.15h2.917V28.267c.867-.15,5.033-.983,5.033-5.367C25.167,20.583,24.15,18.55,20.15,17.167Z",
  transform: "translate(-2 -2)",
  fill: "#93d0a9"
}));

var SvgSifrao = function SvgSifrao(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "paid_black_24dp",
    width: 30,
    height: 30,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSifrao, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Sifrao.3492dba5.svg";
export { ForwardRef as ReactComponent };